import { ReactNode } from 'react'

import { EditableFieldGroups, ManualCompanyFormProps } from '../../ManualCompanyForm'

interface ConditionalFormGroupProps {
  fields: ManualCompanyFormProps['fields']
  name?: EditableFieldGroups
  children: ReactNode
}

export const ConditionalFormGroup = ({ fields, name, children }: ConditionalFormGroupProps) => {
  if (!fields?.length) {
    return children
  }

  // Means we explicitly want to remove it if there are any fields
  if (!name) {
    return null
  }

  if (fields.includes(name)) {
    return children
  }

  return null
}
